import { useEffect } from 'react';
import type { MinimalPersonData } from '@frontend/form-packet-selector';
import { useSendFormsStore } from '../store';

interface UsePersonConfigProps {
  person: MinimalPersonData | null;
  personId?: string | null;
}

const usePersonConfig = ({ person, personId: directPersonId }: UsePersonConfigProps) => {
  const { setPersonId, setPersonName } = useSendFormsStore(['setPersonId', 'setPersonName']);
  // Use directPersonId (from MESSAGING) if provided, otherwise get from person object
  const personId = directPersonId ?? person?.id ?? '';
  const firstName = person?.firstName ?? '';
  const lastName = person?.lastName ?? '';

  useEffect(() => {
    setPersonId(personId);
    setPersonName({
      firstName,
      lastName,
    });
  }, [personId, firstName, lastName, setPersonId, setPersonName]);
};

export default usePersonConfig;
